import { observer } from 'mobx-react'
import './index.scss'
import { ReactComponent as ButIc } from '../../../../assets/things/Group 298.svg'
import { useLocation, useNavigate } from 'react-router'
import classNames from 'classnames'
import GlobalState from '../../../../stores/GlobalState'

const Terms = observer(({ content }: { content: any }) => {
  let lang = GlobalState.currentLocale.lang.includes('En')
    ? '/en'
    : GlobalState.currentLocale.lang.includes('ру')
    ? '/ru'
    : ''


  return (
    <section
      className={classNames(
        'things-terms',
        // pathname.includes('business') && 'dark-theme',
      )}
    >
      <div className="things-terms__list">
        {content.termsTitle && (
          <div className="things-terms__item">
            <div className="things-terms__item-title">{content.termsTitle}</div>
            <div
              className="things-terms__item-text"
              dangerouslySetInnerHTML={{ __html: content.termsText }}
            ></div>
          </div>
        )}
        {content.calcTitle && (
          <div className="things-terms__item">
            <div className="things-terms__item-title">{content.calcTitle}</div>
            <div className="things-terms__item-bottom calc-block">
              <a className="button grey-border" href={lang + content.calсLink}>
                <ButIc />
                {content.calcBut}
              </a>
              <div className="things-terms__item-subtext">
                {content.calcText}
              </div>
            </div>
          </div>
        )}
        {content.howsend.title && (
          <div className="things-terms__item">
            <div className="things-terms__item-title">
              {content.howsend.title}
            </div>
            <div className="things-terms__item-bottom">
              {content.howsend.list.map((li: any, i: number) => (
                <div className="things-terms__item-row" key={i}>
                  <img src={li.icon} /> {li.title}
                </div>
              ))}
            </div>
          </div>
        )}
        {content.howget.title && (
          <div className="things-terms__item">
            <div className="things-terms__item-title">
              {content.howget.title}
            </div>
            <div className="things-terms__item-bottom">
              {content.howget.list.map((li: any, i: number) => (
                <div className="things-terms__item-row" key={i}>
                  <img src={li.icon} /> {li.title}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  )
})

export default Terms
